import { AcceptTermsMessage } from '../../../../commons/acceptTermsMessage/AcceptTermsMessage';
import { formatText } from 'core/i18n';
import withFeatureToggling from '../../../../../hocs/withFeatureToggling/withFeatureToggling';
import withIdentifyMethodParser from '../../../../../hocs/withIdentifyMethodParser';
import { SINGLE_IDENTIFICATION_METHOD_PAGE } from 'constants/featureFlagging';
import React from 'react';

const VideoClauseErrorMessage = ({ isAres, flags, identificationByCountry }) => {
    const identificationMethods = identificationByCountry();
    const isSingleIdentificationMethodPageFFActive = flags?.get(SINGLE_IDENTIFICATION_METHOD_PAGE);
    const SingleIdentificationOption = isSingleIdentificationMethodPageFFActive && identificationMethods.length === 1;

    const text = SingleIdentificationOption
        ? 'identity-gdprErrorCheckboxVideoCallSingleMethod'
        : 'identity-gdprErrorCheckboxVideoCall';

    return <AcceptTermsMessage text={formatText(isAres ? 'identity-gdprErrorCheckboxVideoCall' : text)} />;
};

export default withFeatureToggling(withIdentifyMethodParser(VideoClauseErrorMessage));
